import { render, staticRenderFns } from "./single-post.vue?vue&type=template&id=3ba110b0&lang=pug&"
import script from "./single-post.vue?vue&type=script&lang=js&"
export * from "./single-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports